<div class="overlay">
    <!-- #region FORM TITLE -->
    <div class="edit-contact-popup">
        <div class="popup-head">
            <button class="close-btn-mobile" (click)="closeEditWindow()">
                <img src="assets/icons/cancel-white.svg" alt="cancel button">
            </button>
            <img src="assets/icons/join_logo.svg" alt="Join Logo">
            <h1>Edit contact</h1>
            <div></div>
        </div>
    <!-- #endregion -->
    <!-- #region FILLED FORM -->
        <div class="popup-form">
            <button class="close-btn" (click)="closeEditWindow()"><img src="assets/icons/cancel.svg" alt="cancel button"></button>
            <div class="user-profile-image-wrapper">
                <app-user-profile-image [contact]="contact"></app-user-profile-image>
            </div>
            
            <form (ngSubmit)="onSubmit(contactForm)" #contactForm="ngForm">
                <!-- #region NAME -->
                <div class="input-wrapper">
                    <input #name="ngModel" [(ngModel)]="contactData.name" appPatternValidator="generalName" type="text" name="name" placeholder="Name"
                        required appPatternValidator="generalName" (ngModelChange)="formatName($event)" [ngStyle]="{'border-color': !name.valid && name.touched ? 'red' : '#D9D9D9'}"><img src="assets/icons/person-gray.svg" alt="Input field for name">
                    @if (name.touched){
                        @if (name.hasError('required')){
                            <span>Name is required.</span>
                        } @else if (name.hasError('invalidPattern')) {
                            <span>No numbers, ,,.,#,*,!,$,%,&,\,/,_,",?,~,=,;,:</span>
                        }   
                    }
                    </div>
                <!-- #endregion -->
                <!-- #region EMAIL -->
                <div class="input-wrapper">
                    <input #mail="ngModel" [(ngModel)]="contactData.mail" type="email" name="email" placeholder="Email"
                        required appPatternValidator="emailFormat"
                        [ngStyle]="{'border-color': !mail.valid && mail.touched ? 'red' : '#D9D9D9'}"><img
                        src="assets/icons/mail.svg" alt="Input field for email address">
                    @if (mail.touched){
                        @if(mail.hasError('required')){
                            <span>Email address is required.</span>
                        } @else if (mail.hasError('invalidPattern')) {
                            <span>Please enter a valid email address!</span>
                        }
                    }
                </div>
                <!-- #endregion -->
                <!-- #region PHONE -->
                <div class="input-wrapper">
                    <input #phone="ngModel" [(ngModel)]="contactData.phone" type="text" name="phone" placeholder="Phone"
                        required appPatternValidator="phoneFormat" [ngStyle]="{'border-color': !phone.valid && phone.touched ? 'red' : '#D9D9D9'}"><img src="assets/icons/phone.svg" alt="Input field for phone number">
                    @if (phone.touched){
                        @if(phone.hasError('required')){
                            <span>Phone number is required</span>
                        }@else if (phone.hasError('invalidPattern')) {
                            <span>Please enter a valid number!</span>
                        }
                    }
                </div>
                <!-- #endregion -->
                <!-- #region BUTTONS -->
                <div class="btn-wrapper">
                    <button class="delete-btn" (click)="sendDeleteInput()">Delete</button>
                    <button id="submit-btn" type="submit" [disabled]="!contactForm.valid" [ngClass]="{'btn-disabled': !contactForm.valid, 'btn-enabled': contactForm.valid}">Save<img src="assets/icons/check.svg" alt="check-img"></button>
                </div>
                <!-- #endregion -->
            </form>
        </div>
        <!-- #endregion -->
    </div>
</div>